import React from 'react';
import { Footer as Container, FooterContent } from './style';
import { CodeBox } from './CodeBox';
import { BoardTypeBox } from './BoardTypeBox';
import { TimerBox } from './TimerBox';
import screenWidthProvider from '../../HOCS/ScreenWidthProvider';
import { screenTypes } from '../../../../Constants/screenTypes';

let Footer = ({ boardType, screenWidth, workoutInfo, workoutOwner, ...props }) => {
    return (
        <Container>
            <FooterContent>
                {screenWidth === screenTypes.MOBILE ? null : <CodeBox />}
                {screenWidth === screenTypes.MOBILE ? null : <BoardTypeBox {...props} boardType={boardType} />}
                <TimerBox workoutOwner={workoutOwner} workoutInfo={workoutInfo} />
            </FooterContent>
        </Container>
    );
};

Footer = screenWidthProvider(Footer);
export { Footer };



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/Footer/index.js